import DomainModel from './DomainModel'

export default class Hospital extends DomainModel {
  constructor(private id: string, private name: string, private district: string, private state: string, private pinCode: number, private mergeStatus: boolean) {
    super()
  }

  getId = () => this.id
  getName = () => this.name
  getDistrict = () => this.district
  getState = () => this.state
  getPinCode = () => this.pinCode
  getMergeStatus = () => this.mergeStatus
}
